import { FC } from 'react';
import { RecognitionsLayout } from 'pages/atoms';
import { RecognitionsCommentsList } from 'containers/recognitions';

const RecognitionsCommentsPage: FC = () => {
  return (
    <RecognitionsLayout>
      <RecognitionsCommentsList />
    </RecognitionsLayout>
  );
};

export default RecognitionsCommentsPage;
